import React, { Component } from "react";
import { cardWithItems } from "./Card";
import { ItemCardItemList } from "./item-card";

const items = [
  {
    title: "Google ID",
    value: "id",
    full: true
  },
  {
    title: "ID",
    value: "customerId",
    full: true
  },
  {
    title: "Super Admin",
    value: "superAdmin"
  },
  {
    title: "Primary Domain",
    value: "primaryDomain"
  },
  {
    title: "Domain User",
    value: "numberOfUsers"
  }
];

class CustomerCard extends Component {
  render = () => (
    <ItemCardItemList title={"Domains"} list={this.props.object.domainList} />
  );
}

export default cardWithItems(CustomerCard, items);



// WEBPACK FOOTER //
// ./src/library/card/CustomerCard.js